import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || {},
    isVerified: localStorage.getItem('is_verified') === '1',
    error: null,
};

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setSession: (state, action) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.isVerified = action.payload.isVerified;
            state.error = null;
        },
        clearSession: (state) => {
            state.token = null;
            state.user = {};
            state.isVerified = false;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('is_verified');
            state.error = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setSession, clearSession, setError } = sessionSlice.actions;
export default sessionSlice.reducer;
